import {filter, transform, createSelector} from 'vendor';
import {id, timestamp} from 'store/common';
import {week} from './week';
import {month} from './month';
import {weekly, monthly} from 'store/activities/selectors/activities';
import {eventsProgress} from 'store/google-calendar/selectors';

export const progress = createSelector(
  [ state => state.activities.progress, eventsProgress ],
  ( progress, eventsProgress ) => ({ ...eventsProgress, ...progress }),
);

export const index = createSelector(
  [ progress, weekly, monthly ],
  ( progress, weekly, monthly ) => transform(progress, (result, record) => {
    result[record.timestamp] = result[record.timestamp] || {};
    result[record.timestamp][record.activity_id] = record;

    if (monthly[record.activity_id] && record.status == 'Completed') {
      result['monthlyCompleted'+record.timestamp] = result['monthlyCompleted'+record.timestamp] || [];
      result['monthlyCompleted'+record.timestamp].push(record.activity_id);
    }

    if (weekly[record.activity_id]) {
      result['weekly'+record.timestamp] = result['weekly'+record.timestamp] || {};
      result['weekly'+record.timestamp][record.activity_id] = record.status;
    }

    //google calendar progress
    if (record.originalTimestamp && record.originalTimestamp != record.timestamp) {
      result[record.originalTimestamp] = result[record.originalTimestamp] || {};
      result[record.originalTimestamp][record.activity_id] =  {
        ...record,
        id: record.id + '_rescheduled',
        timestamp: record.originalTimestamp,
        status: 'Rescheduled',
      }
    }
  })
);

export const dayRecords = createSelector(
  [ index, timestamp ],
  ( index, timestamp ) => index[timestamp],
  { memoizeOptions: { maxSize: 1000 } },
);

export const weekRecords = createSelector(
  [ week, index ],
  ( week, index ) => JSON.stringify(week.map(day => ({ timestamp: day.unix(), statuses: index['weekly' + day.unix()] }))),
  { memoizeOptions: { maxSize: 50 } },
);

export const monthCompletedRecords = createSelector(
  [ month, index ],
  ( month, index ) => month.map(day => {
    const key = 'monthlyCompleted' + day.unix();
    return index[key] ? index[key].join(',') : '';
  }).join(','),
  { memoizeOptions: { maxSize: 50 } },
);

export const record = createSelector(
  [ dayRecords, id ],
  ( dayRecords, id ) => dayRecords && dayRecords[id],
);

export const activityRecords = createSelector(
  [ progress, id ],
  ( progress, id ) => filter(progress, { activity_id: id })
);
